import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useHashScroll = (
  offset = 0,
  tabHashHandler?: (hash: string) => void
) => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;

    const id = location.hash.replace("#", "");

    const scrollToElement = () => {
      // If you have a tab handler, call it first
      if (tabHashHandler) tabHashHandler(location.hash);

      const el = document.getElementById(id);
      if (el) {
        const y = el.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: y, behavior: "smooth" });
      } else {
        // Retry until element exists
        setTimeout(scrollToElement, 50);
      }
    };

    scrollToElement();
  }, [location.hash, offset, tabHashHandler]);
};
